import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import '@/sass/variables.scss';
import VueBus from 'vue-bus';
import moment from 'vue-moment';
import VueGtag from 'vue-gtag';
Vue.config.devtools = true

// // Vue.use(
// //   VueGtag,
// //   {
// //     config: { 
// //       id: 'UA-154252976-1' },
// //     appName: 'CPNU',
// //     //pageTrackerScreenviewEnabled: true,
// //   },
// //   router
// // );

Vue.use(
  VueGtag,
  {
    config: { 
      id: 'G-5QZKEC0DBH', 
      params: { 
        user_id: '' 
      }    
    },
    appName: 'CPNU',
    //pageTrackerScreenviewEnabled: true,
  },
  router
);

Vue.use(VueBus);
Vue.use(moment);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
